import {Layout, Typography, Anchor} from 'antd';
import React, {useState} from 'react';
import appColors from '../../style/theme';
import HPOv from './HPOv';
import ApplyingRWE from './ApplyingRWE';
import ExploringNew from './ExploringNew';
import References from './References';

const {Link} = Anchor;
const {Sider, Content} = Layout;
const Text = Typography;

const handleClick = (e, link) => {
  e.preventDefault();
  console.log(link);
};
const ProblemPage = () => {
  const [backI, setBackI] = useState('transparent');
  const [backII, setBackII] = useState('transparent');
  const [backIII, setBackIII] = useState('transparent');
  const [backIV, setBackIV] = useState('transparent');
  const ChangeAnchor = (key) => {
    console.log(key);
    if (key === '#HPOv') {
      setBackI(appColors['ColorB']);
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
    } else if (key === '#ApplyingRWE') {
      setBackI('transparent');
      setBackII(appColors['ColorB']);
      setBackIII('transparent');
      setBackIV('transparent');
    } else if (key === '#ExploringNew') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII(appColors['ColorB']);
      setBackIV('transparent');
    } else if (key === '#References') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV(appColors['ColorB']);
    }
  };

  return (
    <Layout style={{background: 'transparent'}}>
      <Sider style={{background: 'transparent'}}>
        <Anchor onClick={handleClick} offsetTop={75} onChange={ChangeAnchor} style={{background: 'transparent'}}>
          <Link href='#HPOv' title={<Content className='ContentAnchor' style={{borderColor: backI}}><Text style={{color: appColors['ColorB'], fontSize: '2.5vh'}}>Background</Text></Content>}/>
          <Link href='#ApplyingRWE' title={<Content className='ContentAnchor' style={{borderColor: backII}}><Text style={{color: appColors['ColorB'], fontSize: '2.5vh'}}>Applying RWE</Text></Content>}/>
          <Link href='#ExploringNew' title={<Content className='ContentAnchor' style={{borderColor: backIII}}><Text style={{color: appColors['ColorB'], fontSize: '1.5vh'}}>Exploring Perspectives</Text></Content>}/>
          <Link href='#References' title={<Content className='ContentAnchor' style={{borderColor: backIV}}><Text style={{color: appColors['ColorB'], fontSize: '2.5vh'}}>References</Text></Content>}/>
        </Anchor>
        <p style={{color: appColors['ColorB'], pointerEvents: 'none', fontSize: '2vh', top: '65vh', left: '5vh', textAlign: 'center', position: 'sticky'}}> D &nbsp;&nbsp; &nbsp; P <br/> E &nbsp; &nbsp;&nbsp; R<br/>F &nbsp; &nbsp;&nbsp; O<br/>I &nbsp;&nbsp;&nbsp; &nbsp;B<br/>N &nbsp; &nbsp;&nbsp;L<br/>I &nbsp; &nbsp;&nbsp;&nbsp;E<br/>N &nbsp;&nbsp;&nbsp;&nbsp;M<br/>G &nbsp; &nbsp; &nbsp; &nbsp;</p>
      </Sider>
      <Layout style={{margin: '1% 1% 0 1%', width: 'fit-content'}}>
        <Layout style={{background: appColors['ColorX'], height: '1px'}} />
        <Layout className='PurpBack' style={{background: appColors['ColorG']}}>
          <Layout style={{margin: '0 0 0 0', background: 'transparent'}}>
            <div id='HPOv'>
              <HPOv/>
            </div>
            <div id='ApplyingRWE'>
              <ApplyingRWE/>
            </div>
            <div id='ExploringNew'>
              <ExploringNew/>
            </div>
            <div id='References'>
              <References/>
            </div>
          </Layout>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default ProblemPage;
